// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ElevatorControl {
  CarCallLock = 0,
  CarCallUnlock = 1,
  RearCarCallLock = 2,
  RearCarCallUnlock = 3,
  UpHallCallLock = 4,
  UpHallCallUnlock = 5,
  UpRearHallCallLock = 6,
  UpRearHallCallUnlock = 7,
  UpAssignedHallCall = 8,
  UpAssignedRearHallCall = 9,
  DownHallCallLock = 10,
  DownHallCallUnlock = 11,
  DownRearHallCallLock = 12,
  DownRearHallCallUnlock = 13,
  DownAssignedHallCall = 14,
  DownAssignedRearHallCall = 15,
  EnergizeCarCall = 16,
  EnergizeRearCarCall = 17,
  EnergizeUpHallCall = 18,
  EnergizeUpRearHallCall = 19,
  EnergizeDownHallCall = 20,
  EnergizeDownRearHallCall = 21,
  SecureCarCall = 22,
  SecureRearCarCall = 23,
  VIP = 24,
  OpenDoor = 25,
  CloseDoor = 26,
  IndependentService = 27,
  OutOfService = 28,
  CarToLobby = 29
}
